import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'cacheBust'})
export class CacheBustPipe implements PipeTransform {
  transform(url: string): string {
    const version = `${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    return `${url}?v=${version}`;
  }
}
